<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'relatorios' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Relatório de Faltas por Disciplina - Selecione as Turmas
        </h1>
      </v-col>
    </v-row>

    <v-card class="mt-4">
      <v-card-title>
        <v-icon left>groups</v-icon>
        Turmas Disponíveis
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="turmasSelecionadas"
          :headers="headers"
          :items="turmas"
          :loading="loading"
          item-key="id"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.descricao="{ item }">
            {{ item.descricao }}
          </template>
          <template v-slot:item.curso="{ item }">
            {{ item.curso?.descricao || "---" }}
          </template>
          <template v-slot:item.turno="{ item }">
            {{ item.turno?.descricao || "---" }}
          </template>
          <template v-slot:item.qtd_alunos="{ item }">
            {{ item.matriculas_count || 0 }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="turmasSelecionadas.length === 0" @click="gerarRelatorios">
          Gerar Relatórios
          <v-icon right>picture_as_pdf</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </main-template>
</template>

<script>
export default {
  name: "FaltasDisciplinaTurmasPage",
  data() {
    return {
      turmas: [],
      turmasSelecionadas: [],
      loading: false,
      headers: [
        { text: "Turma", value: "descricao", sortable: true },
        { text: "Curso", value: "curso", sortable: true },
        { text: "Turno", value: "turno", sortable: true },
        { text: "Qtd. Alunos", value: "qtd_alunos", sortable: true },
      ],
    };
  },
  async mounted() {
    await this.loadTurmas();
  },
  methods: {
    async loadTurmas() {
      try {
        this.loading = true;
        const franquiaId = this.$route.params.franquia_id;

        const response = await this.$services.turmasService.syncAll({
          configuracao_id: franquiaId,
        });

        this.turmas = response || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async gerarRelatorios() {
      try {
        this.$loaderService.open("Gerando relatórios...");

        for (const turma of this.turmasSelecionadas) {
          await this.$services.relatoriosService.faltasPorDisciplinaTurma(parseInt(turma.id, 10));
        }

        this.$toast.success(
          `${this.turmasSelecionadas.length} relatório(s) gerado(s) com sucesso!`
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px !important;
}

.v-card-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>
